import { useEffect, useState } from "react";

// True while the user is actively scrolling; flips back false ~`delay`ms
// after scrolling stops. Used to auto-hide floating mobile controls so
// they never obscure content mid-read.
export const useScrollIdle = (delay = 450) => {
  const [scrolling, setScrolling] = useState(false);
  useEffect(() => {
    let t;
    const onScroll = () => {
      setScrolling(true);
      clearTimeout(t);
      t = setTimeout(() => setScrolling(false), delay);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t);
    };
  }, [delay]);
  return scrolling;
};

export default useScrollIdle;
